import { useEffect, useState } from "react";

export const useCompletedUploads = () => {
  const [completedUploads, setCompletedUploads] = useState([]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCompletedUploads([]);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [completedUploads]);

  const addCompletedUpload = fileId => {
    setCompletedUploads(prevUploads => [...prevUploads, fileId]);
  };

  return { completedUploads, addCompletedUpload };
};
